import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import usePageMeta from '../hooks/usePageMeta';

function Shipping() {
  usePageMeta({
    title: 'Shipping Policy | WearTwice',
    description: 'Details on WearTwice shipping and delivery via AJEX, including delivery times, fees and return shipping across the UAE.',
    path: '/shipping-policy',
  });

  return (
    <>
      <section className="relative w-full h-auto bg-[#47715B] p-8">
      <div className="max-w-3xl mx-auto bg-[#47715B] rounded-lg p-6 text-white">
        <h1 className="text-2xl font-bold mb-4">Weartwice - Shipping Policy</h1>

        <p className="mt-4">
          At Weartwice, we aim to provide smooth, reliable, and affordable shipping services in
          collaboration with <strong>"AJEX"</strong>, our trusted shipping partner. This policy
          outlines the key points regarding shipping for both buyers and sellers on our platform.
        </p>

        <h2 className="text-xl font-bold mt-6">1 - SHIPPING PARTNER</h2>
        <p className="mt-4">
          All shipments will be handled by <strong>AJEX</strong>, an experienced logistics
          provider offering domestic and international shipping services across the UAE and beyond.
        </p>

        <h2 className="text-xl font-bold mt-6">2 - SHIPPING RATES</h2>
        <div className="text-left">
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Domestic Shipping (within UAE):</strong>
              <ul className="list-[circle] pl-5 space-y-1">
                <li>1 small = 1 kg</li>
                <li>2 small = 2 kg = 1 medium</li>
                <li>2 medium = 4 kg = 1 large</li>
                <li>2 large = 8 kg = 1 Heavy Parcel</li>
                <li>Heavy Parcel = 8 kg and above = 30 AED</li>
              </ul>
            </li>
          </ul>
        </div>
        <p className="mt-4">
          <strong>NOTE : </strong>All rates are exclusive of government taxes, duties, and any
          additional services. Shipping charges are calculated based on the greater of actual or
          dimensional weight.
        </p>

        <h2 className="text-xl font-bold mt-6">3 - DELIVERY TIME</h2>
        <div className="text-left">
          <ul className="list-disc pl-5 space-y-2">
            <ul className="list-[circle] pl-5 space-y-1">
              <li>
                Domestic shipments within the UAE typically take 1 business day (with end-of-day delivery).
              </li>
              <li>Shipments to more remote areas may take slightly longer.</li>
            </ul>
          </ul>
        </div>

        <h2 className="text-xl font-bold mt-6">4 - SHIPPING PROCESS</h2>
        <div className="text-left">
          <ul className="list-disc pl-5 space-y-2">
            <ul className="list-[circle] pl-5 space-y-1">
              <li>
                Orders will be processed and shipped through AJEX's automated shipping system,
                allowing for real-time tracking and proactive notifications to both the seller and buyer.
              </li>
              <li>A proof of delivery will be provided once the item is delivered</li>
            </ul>
          </ul>
        </div>

        <h2 className="text-xl font-bold mt-6">5 - SELLERS'RESPONSIBILITIES</h2>
        <div className="text-left pl-5 space-y-2">
          <p className="font-semibold">Sellers are required to :</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Provide accurate packaging size for the shipment</li>
            <li>Ensure that the shipping address is correct.</li>
          </ul>
          <p className="font-semibold">Mandatory AJEX Shipping</p>
          <p className="mt-4">All shipments must be carried out exclusively through AJEX using the integrated shipping tools provided by Weartwice. Sellers are not permitted to arrange delivery independently or through external carriers. Failure to use the mandatory shipping method makes it impossible for Weartwice to validate delivery, provide Buyer Protection, or resolve disputes, and may result in removal of the listing or further action.</p>
        </div>

        <h2 className="text-xl font-bold mt-6">6 - BUYERS'RESPONSIBILITIES</h2>
        <div className="text-left pl-5 space-y-2">
          <p className="font-semibold">Buyers should :</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Ensure the delivery address is accurate and accessible.</li>
            <li>
              Be available or have someone present to receive the shipment. In the case of missed
              deliveries, <strong>AJEX</strong> may offer alternative delivery options or redirection
            </li>
          </ul>
        </div>

        <h2 className="text-xl font-bold mt-6">7 - UNDELIVRABLE SHIPMENTS</h2>
        <div className="text-left pl-5 space-y-2">
          <p className="font-semibold">If the shipment cannot be delivered due to reasons such as :</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Incorrect address</li>
            <li>Inability to reach the receiver</li>
            <li>
              Refusal to accept the package or pay duties (if applicable), The item will be
              returned to the seller, and the cost of return shipping will be borne by the seller
            </li>
          </ul>
        </div>

        <h2 className="text-xl font-bold mt-6">8 - RETURN & REFUND POLICY</h2>
        <p className="mt-4">
          In the event of a return, buyers must follow the instructions set out in the Weartwice Refund and Return Policy. AJEX provides a Return to Shipper service. Returns are covered free of charge within a reasonable usage limit, in line with the return quota allocated to each buyer. Beyond this threshold, specific conditions may apply.
        </p>
      </div>

        <div className="flex justify-center mt-8">
          <Link
            to="/"
            className="bg-white text-[#47715B] px-4 py-2 rounded-lg shadow hover:bg-gray-200 transition duration-300"
          >
            Back to Home
          </Link>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Shipping;
